import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue";
const _hoisted_1 = { class: "image-gallery__modal p-4" };
const _hoisted_2 = { class: "image-gallery" };
const _hoisted_3 = {
    key: 0,
    class: "thumbnail"
};
const _hoisted_4 = { class: "h-100 position-relative" };
const _hoisted_5 = { class: "thumbnail__container" };
const _hoisted_6 = ["onMouseover"];
const _hoisted_7 = { class: "image-wrapper" };
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = {
    class: "image",
    style: { "padding": "20px" }
};
const _hoisted_10 = { class: "image__container" };
const _hoisted_11 = ["src", "alt"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_video = _resolveComponent("g-video");
    const _component_g_button = _resolveComponent("g-button");
    const _component_g_window_view = _resolveComponent("g-window-view");
    return (_openBlock(), _createBlock(_component_g_window_view, {
        title: _ctx.title,
        "class-content": "m-0 h-100"
    }, {
        "modal-footer": _withCtx(() => [
            _createVNode(_component_g_button, {
                text: "Schließen",
                onClick: _ctx.currentWindow.close,
                type: "normal",
                class: "w-fixed-150"
            }, null, 8, ["onClick"])
        ]),
        default: _withCtx(() => [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    (_ctx.images && _ctx.images.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                            _createElementVNode("div", _hoisted_4, [
                                _createElementVNode("div", _hoisted_5, [
                                    _createElementVNode("ul", {
                                        onScroll: _cache[0] || (_cache[0] = ($event) => (_ctx.OnScroll($event)))
                                    }, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.images, (image) => {
                                            return (_openBlock(), _createElementBlock("li", null, [
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(["image-container", { 'image-active': _ctx.isActiveImage(image) }]),
                                                    onMouseover: ($event) => (_ctx.OnSelect($event, image))
                                                }, [
                                                    _createElementVNode("div", _hoisted_7, [
                                                        (_ctx.isVideo(image.address))
                                                            ? (_openBlock(), _createBlock(_component_g_video, {
                                                                key: 0,
                                                                mode: "thumbnail",
                                                                src: image.address,
                                                                class: "gallery-image",
                                                                alt: image.caption
                                                            }, null, 8, ["src", "alt"]))
                                                            : (_openBlock(), _createElementBlock("img", {
                                                                key: 1,
                                                                src: image.previewUrl,
                                                                class: "gallery-image",
                                                                alt: image.caption
                                                            }, null, 8, _hoisted_8))
                                                    ])
                                                ], 42, _hoisted_6)
                                            ]));
                                        }), 256))
                                    ], 32)
                                ])
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_9, [
                        _createElementVNode("div", _hoisted_10, [
                            (_ctx.isVideo(_ctx.currentImage?.address))
                                ? (_openBlock(), _createBlock(_component_g_video, {
                                    key: 0,
                                    mode: "player",
                                    src: _ctx.currentImage?.address,
                                    class: "gallery-image",
                                    alt: _ctx.currentImage?.caption
                                }, null, 8, ["src", "alt"]))
                                : (_openBlock(), _createElementBlock("img", {
                                    key: 1,
                                    src: _ctx.currentImage?.originalUrl ?? _ctx.currentImage?.fullUrl,
                                    class: "gallery-image",
                                    onMouseleave: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.imgMouseLeave && _ctx.imgMouseLeave(...args))),
                                    onMousemove: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.imgMouseMove && _ctx.imgMouseMove(...args))),
                                    alt: _ctx.currentImage?.caption,
                                    onClick: _cache[3] || (_cache[3] =
                                        //@ts-ignore
                                        (...args) => (_ctx.imgMouseEntry && _ctx.imgMouseEntry(...args)))
                                }, null, 40, _hoisted_11))
                        ])
                    ])
                ])
            ])
        ]),
        _: 1
    }, 8, ["title"]));
}
